import { assetUrls } from './assets'

const mascot = assetUrls(
  import.meta.glob<string>('../../../assets/svg/mascot/*.svg', { eager: true, query: '?no-inline', import: 'default' }),
)

const layout = assetUrls(
  import.meta.glob<string>('../../../assets/svg/mascot/layout/*.svg', {
    eager: true,
    query: '?no-inline',
    import: 'default',
  }),
)

export const Mascot = {
  Cry: mascot('cry'),
  Default: mascot('default'),
  Happy: mascot('happy'),
  NewYear: mascot('new_year'),
  Sad: mascot('sad'),
  ScaredFace: mascot('scared_face'),
  Sunglass: mascot('sunglass'),
  Sunglass2: mascot('sunglass_2'),
  Wine: mascot('wine'),
  Wink: mascot('wink'),
  Wonder: mascot('wonder'),
}

export const MascotLayout = {
  Gift: layout('gift'),
  Surprised: layout('surprised'),
  ProPlan: layout('pro_plan'),
}
